import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaLinkedin, FaTwitter, FaFacebook } from "react-icons/fa";

export default function Footer() {
    const { t } = useTranslation();

    return (
        <footer className="bg-gradient-to-b from-vsgray-dark to-black text-gray-300 border-t border-gray-800/50">
            <div className="max-w-7xl mx-auto px-6 py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                    {/* Brand Section */}
                    <div className="lg:col-span-2">
                        <div className="flex items-center gap-3 mb-4">
                            <img
                                src="/assets/images/logo.png"
                                alt="VSGrill Logo"
                                className="h-12 w-auto object-contain"
                            />
                            <div>
                                <h3 className="text-white font-bold text-2xl font-serif">VSGrill</h3>
                                <p className="text-xs text-gray-400">Premium Charcoal Supply</p>
                            </div>
                        </div>
                        <p className="text-gray-400 leading-relaxed mb-6 max-w-md">
                            {t('footer.description')}
                        </p>

                        {/* Social Links */}
                        <div className="flex items-center gap-3">
                            {/* eslint-disable-next-line */}
                            <a
                                href="#"
                                className="w-10 h-10 bg-vsblackLight hover:bg-vsred border border-gray-800 hover:border-vsred rounded-lg flex items-center justify-center transition-all duration-300 hover:shadow-red-glow"
                                aria-label="LinkedIn"
                            >
                                <FaLinkedin className="text-lg" />
                            </a>
                            {/* eslint-disable-next-line */}
                            <a
                                href="#"
                                className="w-10 h-10 bg-vsblackLight hover:bg-vsred border border-gray-800 hover:border-vsred rounded-lg flex items-center justify-center transition-all duration-300 hover:shadow-red-glow"
                                aria-label="Twitter"
                            >
                                <FaTwitter className="text-lg" />
                            </a>
                            {/* eslint-disable-next-line */}
                            <a
                                href="#"
                                className="w-10 h-10 bg-vsblackLight hover:bg-vsred border border-gray-800 hover:border-vsred rounded-lg flex items-center justify-center transition-all duration-300 hover:shadow-red-glow"
                                aria-label="Facebook"
                            >
                                <FaFacebook className="text-lg" />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="text-white font-bold text-lg mb-4 font-serif">{t('footer.quickLinks')}</h4>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/" className="text-gray-400 hover:text-vsred-light transition-colors duration-300 flex items-center gap-2 group">
                                    <span className="w-1 h-1 bg-vsred rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                                    {t('nav.home')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/products" className="text-gray-400 hover:text-vsred-light transition-colors duration-300 flex items-center gap-2 group">
                                    <span className="w-1 h-1 bg-vsred rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                                    {t('nav.products')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/gallery" className="text-gray-400 hover:text-vsred-light transition-colors duration-300 flex items-center gap-2 group">
                                    <span className="w-1 h-1 bg-vsred rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                                    {t('nav.gallery')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/about" className="text-gray-400 hover:text-vsred-light transition-colors duration-300 flex items-center gap-2 group">
                                    <span className="w-1 h-1 bg-vsred rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                                    {t('nav.about')}
                                </Link>
                            </li>
                            <li>
                                <a href="/#quote" className="text-gray-400 hover:text-vsred-light transition-colors duration-300 flex items-center gap-2 group">
                                    <span className="w-1 h-1 bg-vsred rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                                    {t('nav.requestQuote')}
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="text-white font-bold text-lg mb-4 font-serif">{t('footer.contact')}</h4>
                        <ul className="space-y-4">
                            <li className="flex items-start gap-3 group">
                                <FaEnvelope className="text-vsred mt-1 flex-shrink-0" />
                                <div>
                                    <p className="text-sm text-gray-500 mb-1">{t('footer.email')}</p>
                                    <a href="mailto:sales@vsgrill.pl" className="text-gray-300 hover:text-vsred-light transition-colors">
                                        sales@vsgrill.pl
                                    </a>
                                </div>
                            </li>
                            <li className="flex items-start gap-3 group">
                                <FaPhone className="text-vsred mt-1 flex-shrink-0" />
                                <div>
                                    <p className="text-sm text-gray-500 mb-1">{t('footer.phone')}</p>
                                    <a href="tel:+31612345678" className="text-gray-300 hover:text-vsred-light transition-colors">
                                        +48 452 667 240
                                        <br></br>
                                        +48 511 312 088
                                    </a>
                                </div>
                            </li>
                            <li className="flex items-start gap-3 group">
                                <FaMapMarkerAlt className="text-vsred mt-1 flex-shrink-0" />
                                <div>
                                    <p className="text-sm text-gray-500 mb-1">{t('footer.location')}</p>
                                    <p className="text-gray-300">
                                        {t('footer.poznan')}
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="mt-12 pt-8 border-t border-gray-800/50">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-sm text-gray-500 text-center md:text-left">
                            © {new Date().getFullYear()} VSGrill. {t('footer.copyright')}
                        </p>
                        <div className="flex items-center gap-6 text-sm">
                            {/* eslint-disable-next-line */}
                            <a href="#" className="text-gray-500 hover:text-vsred-light transition-colors">
                                {t('footer.privacy')}
                            </a>
                            {/* eslint-disable-next-line */}
                            <a href="#" className="text-gray-500 hover:text-vsred-light transition-colors">
                                {t('footer.terms')}
                            </a>
                            {/* eslint-disable-next-line */}
                            <a href="#" className="text-gray-500 hover:text-vsred-light transition-colors">
                                {t('footer.logistics')}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
